/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */

/**
 * Base modules
 */
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';

/**
 * Shared modules
 */
import { AppRoutingModule } from './shared/routing/app-routing.module';
import { HeaderModule } from './shared/header/header.module';
import { FooterModule } from './shared/footer/footer.module';

/**
 * Page Component modules
 */
import { HomeModule } from './components/home/home.module';
import { LoginModule } from './components/login/login.module';
import { ConsignmentsModule } from './components/consignments/consignments.module';
import { ConsignmentDetailModule} from './components/consignment-detail/consignment-detail.module'

/**
 * Providers & Services
 */
import { HttpClientModule } from '@angular/common/http';
import { BaseSettingsService } from './providers/base-settings.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HeaderModule,
    FooterModule,
    HomeModule,
    LoginModule,
    ConsignmentsModule,
    ConsignmentDetailModule,
    HttpClientModule
  ],
  providers: [
    BaseSettingsService
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
